import { render } from "./BulmaModal.vue?vue&type=template&id=3ba87762"
import script from "./BulmaModal.vue?vue&type=script&lang=js"
export * from "./BulmaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__